import type { ScheduleViewGroupByArrangement } from "@/pages/human-resources/time-management/model/ScheduleViewArrangement.ts";
import type { EmployeesOrder } from "@/pages/human-resources/time-management/model/ScheduleEmployeesOrder.ts";

export type PrintSortTypeIn =
  | "EMPLOYEE_NAME"
  | "SECTION"
  | "ROLE"
  | "CONTRACT_START"
  | "ARRIVAL";

export function mapFromGroupedArrangement(
  viewArrangement: ScheduleViewGroupByArrangement,
): PrintSortTypeIn {
  switch (viewArrangement) {
    case "section":
      return "SECTION";
    case "role":
      return "ROLE";
  }
}

export function mapFromEmployeeOrder(order: EmployeesOrder): PrintSortTypeIn {
  switch (order) {
    case "name":
      return "EMPLOYEE_NAME";
    case "arrival": // Order by arrival is not supported by backend
      return "ARRIVAL";
    case "role":
      return "ROLE";
    case "contractStart":
      return "CONTRACT_START";
  }
}
